import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Resume } from 'src/app/shared/models/resume';
import { SearchResult } from 'src/app/shared/models/search-result';
import { CandidateSummary } from '../models/candidate-summary';
import { CandidatesFilter } from '../models/candidates-filter';
import { DataService } from '../services/data.service';

@Injectable({
  providedIn: 'root'
})
export class CandidatesStore {

  _candidateSearchFilter: BehaviorSubject<CandidatesFilter> = new BehaviorSubject(new CandidatesFilter());
  public readonly candidateSearchFilter: Observable<CandidatesFilter> = this._candidateSearchFilter.asObservable();

  _candidateSearchResult: BehaviorSubject<SearchResult<CandidateSummary>> = new BehaviorSubject(null);
  public readonly candidateSearchResults: Observable<SearchResult<CandidateSummary>> = this._candidateSearchResult.asObservable();

  _resume: BehaviorSubject<Resume> = new BehaviorSubject(null);
  public readonly resume: Observable<Resume> = this._resume.asObservable();

  constructor(private dataService: DataService) {
  }

  loadSearchResults(candidatesFilter: CandidatesFilter) {
    this.dataService.filterCandidates(candidatesFilter).subscribe(result => {
      if (!result) {
        this._candidateSearchResult.next(new SearchResult<CandidateSummary>());
        return;
      }

      this._candidateSearchResult.next(result);
    });
  }

  getResume(resumeId: string): void {
    this.dataService.getResume(resumeId).subscribe(r => {
      this._resume.next(r);
    });
  }
}
